// Which solutions the report covers: selected ones (one or more), or all of them. The list offers only
// solutions the user holds in full for the chosen sections; a selected one outside that list stays visible
// and marked, so the user can see and remove it.
import React from "react";
import {
  Autocomplete,
  Chip,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

export default function ScopePicker({ scope, onChange, offered, services, canAll, deniedIds, error }) {
  const offeredIds = new Set(offered.map((s) => String(s.id)));
  const selected = scope.serviceIds.map(
    (id) => (services || []).find((s) => String(s.id) === id) || { id, name: "A solution that no longer exists" }
  );
  const options = [...offered, ...selected.filter((s) => !offeredIds.has(String(s.id)))];
  const marked = (s) => !offeredIds.has(String(s.id)) || (deniedIds || []).includes(String(s.id));

  return (
    <div>
      {canAll ? (
        <RadioGroup row value={scope.mode} onChange={(e) => onChange({ ...scope, mode: e.target.value })}>
          <FormControlLabel value="solutions" control={<Radio size="small" color="secondary" />} label="Selected solutions" />
          <FormControlLabel value="all" control={<Radio size="small" color="secondary" />} label="All solutions" />
        </RadioGroup>
      ) : null}
      {scope.mode === "all" ? (
        <p style={{ fontSize: "13px", color: "grey", margin: "4px 0 0 0" }}>
          Covers every solution of this account. New solutions join the report by themselves.
        </p>
      ) : (
        <Autocomplete
          multiple
          disableCloseOnSelect
          size="small"
          options={options}
          value={selected}
          getOptionLabel={(s) => s.name || ""}
          isOptionEqualToValue={(a, b) => String(a.id) === String(b.id)}
          onChange={(e, value) => onChange({ ...scope, serviceIds: value.map((s) => String(s.id)) })}
          renderTags={(value, getTagProps) =>
            value.map((s, index) => (
              <Chip {...getTagProps({ index })} size="small" label={s.name} color={marked(s) ? "error" : "default"} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Solutions"
              error={!!error}
              helperText={error || (selected.some(marked) ? "The marked solutions are not held in full for the chosen sections. Remove them to save." : " ")}
            />
          )}
        />
      )}
    </div>
  );
}
